import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/launch")({
  component: () => <Navigate to="/join" replace />,
});
